import { ErrorState } from "@packages/core-client/errors/ErrorState.tsx";
import { ErrorStateBackLink } from "@packages/core-client/errors/ErrorStateBackLink.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useTranslation } from "react-i18next";
import { i18NextInstanceKey } from "../../../i18n/i18next.ts";

export function PersonNotFound() {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("PersonNotFound", { i18n: i18nextInstance });

    return <ErrorState kind="notFound" ownsPageTitle title={t("heading")} action={<ErrorStateBackLink href="/settings/people">{t("backToManagePeople")}</ErrorStateBackLink>} />;
}
